import { StadiumMaterialuEnum } from '../model/StadiumMaterialu';
import StadiumMaterialuHistoria from '../model/StadiumMaterialuHistoria';

export default (
  stadium: StadiumMaterialuEnum,
  historiaRecords: Array<StadiumMaterialuHistoria>,
): boolean => historiaRecords?.map(record => record.stadium.hodnota).includes(stadium);
